var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoWLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "919px",
    height: "882px",
    viewBox: "0 0 919 882",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WoW-Book-Icons",
    transform: "translate(-9904.000000, -6912.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WoW-Logo-Copy-2",
    transform: "translate(9904.000000, 6913.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-rectangle-background",
    transform: "translate(25.000000, 0.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#616063",
    x: 8,
    y: 8,
    width: 872,
    height: 872,
    rx: 92
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00D2C9",
    x: 0,
    y: 0,
    width: 872,
    height: 872,
    rx: 92
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 94,
    width: 919,
    height: 684
  }), /*#__PURE__*/React.createElement("g", {
    id: "OIB-iPhone-LOGO-Icon-Shape-of-Work-Copy-10",
    transform: "translate(92.000000, 182.000000)",
    stroke: "#616063",
    strokeWidth: 45
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 344.080499,
    cy: 274.912698,
    r: 240.914966
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.485611818,
    y1: 0.5861678,
    x2: 231.636837,
    y2: 0.5861678,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.383571,
    y1: 516.413832,
    x2: 755.534796,
    y2: 516.413832,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OIB-iPhone-LOGO-Icon-Shape-of-Work-Copy-11",
    transform: "translate(87.000000, 177.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 45
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 344.080499,
    cy: 274.912698,
    r: 240.914966
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.485611818,
    y1: 0.5861678,
    x2: 231.636837,
    y2: 0.5861678,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.383571,
    y1: 516.413832,
    x2: 755.534796,
    y2: 516.413832,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoWLogo);
export default __webpack_public_path__ + "static/media/WoWLogo.a3f479135be1bc62e353427299f81bf8.svg";
export { ForwardRef as ReactComponent };